import smoothscroll from 'smoothscroll-polyfill';
import breadcrumbs from './../components/breadcrumbs';
import video from './../components/video';
import timetable from './../components/timetable';
import animation from './../common/animation';

export default {
  init() {
    // JavaScript to be fired on all pages
    smoothscroll.polyfill();

    $('.navbar-toggler').on('click', () => {
      $('body').toggleClass('nav-open');
    });

    breadcrumbs.init();
    video.init();
    timetable.init();

    const $slides = $('.partner-schools-block .slider .slide'),
          $slider = $('.partner-schools-block .slider'),
          $slidesLength = $slides.length;


    if ($slidesLength < 4 && !$slider.hasClass('slick-initialized')) {
      $slider.on('init', () => {
        $(this).find('.slick-slide').addClass('slick-active');
      });
    }
    if ($slidesLength > 1 && !$slider.hasClass('slick-initialized')) {
      let responsiveSettings = [];
      responsiveSettings = [
        {
          breakpoint: 575,
          settings: {
            centerMode: true,
            centerPadding: 0,
            slidesToShow: 3,
            // slidesToShow: (($slidesLength >= 3) ? 3 : $slidesLength),
          },
        },
        {
          breakpoint: 767,
          settings: {
            centerMode: true,
            centerPadding: 0,
            slidesToShow: 4,
            // slidesToShow: (($slidesLength >= 4) ? 4 : $slidesLength),
          },
        },
        {
          breakpoint: 991,
          settings: {
            centerMode: true,
            centerPadding: 0,
            slidesToShow: 5,
            // slidesToShow: (($slidesLength >= 5) ? 5 : $slidesLength),
          },
        },
        {
          breakpoint: 1279,
          settings: {
            centerMode: true,
            centerPadding: 0,
            slidesToShow: 6,
            // slidesToShow: (($slidesLength >= 6) ? 6 : $slidesLength),
          },
        },
        {
          breakpoint: 1439,
          settings: {
            centerMode: true,
            centerPadding: 0,
            slidesToShow: 7,
            // slidesToShow: (($slidesLength >= 7) ? 7 : $slidesLength),
          },
        },
      ];

      $slider.slick({
        autoplay: true,
        slidesToScroll: 1,
        swipeToSlide: true,
        draggable: true,
        infinite: true,
        arrows: false,
        dots: false,
        centerMode: true,
        centerPadding: 0,
        slidesToShow: 1,
        // variableWidth: true,
        mobileFirst: true,
        responsive: responsiveSettings,
      });
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    animation.init();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js